import { BlitzPage } from "@blitzjs/next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import Layout from "src/app/core/layouts/Layout"
import { Privacy } from "src/app/core/components/Privacy"

const PrivacyPage: BlitzPage = () => {
  return <Privacy />
}

PrivacyPage.suppressFirstRenderFlicker = true
PrivacyPage.getLayout = (page) => (
  <Layout title="Privacy Verklaring | Foto's Op School">{page}</Layout>
)

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  }
}

export default PrivacyPage
